// Rutas de la API
const APIDirectorio = 'https://du0mf0f0ndffc.cloudfront.net/wsCompusoluciones';
// const APIPortal = 'http://serviciosfinancieroscolpruebas-env.eba-p9tsib8p.us-east-1.elasticbeanstalk.com';
// const APIPortal = 'https://d23lkns1ce75gn.cloudfront.net';
const APIPortal = 'https://d1vb8h4ybyu7bq.cloudfront.net';
// const APIPortal = 'http://localhost:888/wsCompusoluciones';
const Apisincronizacion = 'https://ws.compusoluciones.com/Apisincronizacionv2/api';
const ApisincronizacionLocal = 'https://localhost:7120/api';


export const URL = APIPortal;

export const AUTH = {
    // ValidarUsuario: APIPortal + '/auth/login',
    login: APIPortal + '/auth/login',
    loginMS: APIPortal + '/auth/microsoft-login-url',
    exchangeLoginCode: APIPortal + '/auth/exchange-login-code',
    logout: APIPortal + '/auth/logout',
    refresh: APIPortal + '/auth/refresh',
    loginWindows: APIPortal + '/auth/login-windows',
    ENCRIPTACION: APIDirectorio + '/Encriptacion',
    GetDataID: APIDirectorio + '/GetData',
    // ValidarAcceso: ApisincronizacionLocal + '/Calendar_Access/Permissions',
    // ValidarAcceso: Apisincronizacion + '/Calendar_Access/Permissions',
    // ValidarAcceso: ApisincronizacionLocal + '/Calendar_Access/Permissions',
}

export const GETDATA = {
    GetDataID: APIDirectorio + '/GetData',
}

export const ACCESOS = {
    ReenviarCorreo: APIDirectorio + '/acceso/reenviarcorreo'
}


